import { createSvgIcon } from '@mui/material';

export const SB = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='76'
    height='76'
    viewBox='0 0 76 76'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.5391 10.1543C24.5195 10.1543 23.693 10.9808 23.693 12.0005V15.6928H19.0776C18.058 15.6928 17.2314 16.5193 17.2314 17.5389V50.7697C17.2314 51.7893 18.058 52.6158 19.0776 52.6158H36.3084V52.2505C36.3084 51.0213 36.7967 49.8424 37.6658 48.9733C38.535 48.1041 39.7138 47.6158 40.943 47.6158H44.0584C44.6082 47.6158 45.148 47.7136 45.6545 47.8994V42.9043C45.6545 41.6751 46.1428 40.4963 47.012 39.6271C47.8811 38.758 49.06 38.2697 50.2891 38.2697H53.4045C53.9544 38.2697 54.4942 38.3674 55.0007 38.5532V33.5581C55.0007 32.329 55.489 31.1501 56.3581 30.281C57.2273 29.4118 58.4061 28.9235 59.6353 28.9235H61.2314V17.5389C61.2314 16.5193 60.4049 15.6928 59.3853 15.6928H54.7699V12.0005C54.7699 10.9808 53.9434 10.1543 52.9238 10.1543H48.9238C47.9042 10.1543 47.0776 10.9808 47.0776 12.0005V15.6928H31.3853V12.0005C31.3853 10.9808 30.5587 10.1543 29.5391 10.1543H25.5391Z'
      fill='url(#paint0_linear_515_248)'
    />
    <rect
      x='23.6924'
      y='36.9819'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#2979FF'
    />
    <rect
      x='47.0479'
      y='24.6152'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#2979FF'
    />
    <rect
      x='23.6924'
      y='24.6152'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#2979FF'
    />
    <rect
      x='35.3701'
      y='36.9819'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#2979FF'
    />
    <rect
      x='35.3701'
      y='24.6152'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#2979FF'
    />
    <rect
      x='23.6924'
      y='35.751'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#ffffff'
    />
    <rect
      x='23.6924'
      y='23.3848'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#ffffff'
    />
    <rect
      x='25.2305'
      y='25.3208'
      width='4.76923'
      height='5.0506'
      rx='0.829431'
      fill='#C86904'
    />
    <rect
      x='25.2305'
      y='25.0127'
      width='4.76923'
      height='5.0506'
      rx='0.829431'
      fill='url(#paint1_linear_515_248)'
    />
    <rect
      x='35.3701'
      y='35.751'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#ffffff'
    />
    <rect
      x='35.3848'
      y='23.3848'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#ffffff'
    />
    <rect
      x='47.0771'
      y='23.3848'
      width='7.84475'
      height='8.30756'
      rx='1.3643'
      fill='#ffffff'
    />
    <rect
      x='47.0771'
      y='10.1543'
      width='7.84615'
      height='10.7692'
      rx='1.84615'
      fill='#2962FF'
    />
    <rect
      x='47.0771'
      y='8.92334'
      width='8'
      height='9.23077'
      rx='1.84615'
      fill='url(#paint2_linear_515_248)'
    />
    <rect
      x='23.6924'
      y='10.1543'
      width='7.84615'
      height='10.7692'
      rx='1.84615'
      fill='#2962FF'
    />
    <rect
      x='23.6924'
      y='8.92334'
      width='8'
      height='9.23077'
      rx='1.84615'
      fill='url(#paint3_linear_515_248)'
    />
    <path
      d='M62.7502 32.9233H59.6348C59.2217 32.9233 58.8255 33.0875 58.5334 33.3796C58.2413 33.6717 58.0771 34.0679 58.0771 34.481V59.7186C58.0771 60.3983 58.6282 60.9493 59.3079 60.9493H63.0771C63.7569 60.9493 64.3079 60.3983 64.3079 59.7186V34.481C64.3079 34.0679 64.1438 33.6717 63.8517 33.3796C63.5596 33.0875 63.1634 32.9233 62.7502 32.9233Z'
      fill='#C86904'
    />
    <path
      d='M62.7502 32.3081H59.6348C59.2217 32.3081 58.8255 32.4722 58.5334 32.7643C58.2413 33.0565 58.0771 33.4527 58.0771 33.8658V56.0264C58.0771 56.7061 58.6282 57.2572 59.3079 57.2572H63.0771C63.7569 57.2572 64.3079 56.7062 64.3079 56.0264V33.8658C64.3079 33.4527 64.1438 33.0565 63.8517 32.7643C63.5596 32.4722 63.1634 32.3081 62.7502 32.3081Z'
      fill='url(#paint4_linear_515_248)'
    />
    <path
      d='M50.2882 42.2695H53.4035C53.8167 42.2695 54.2129 42.4336 54.505 42.7258C54.7971 43.0179 54.9612 43.4141 54.9612 43.8272V59.7186C54.9612 60.3983 54.4102 60.9494 53.7305 60.9494H49.9612C49.2815 60.9494 48.7305 60.3983 48.7305 59.7186V43.8272C48.7305 43.4141 48.8946 43.0179 49.1867 42.7258C49.4788 42.4336 49.875 42.2695 50.2882 42.2695Z'
      fill='#2962FF'
    />
    <path
      d='M40.9425 51.6157H44.0578C44.471 51.6157 44.8672 51.7798 45.1593 52.072C45.4514 52.3641 45.6155 52.7603 45.6155 53.1734V59.7186C45.6155 60.3984 45.0645 60.9494 44.3848 60.9494H40.6155C39.9358 60.9494 39.3848 60.3984 39.3848 59.7186V53.1734C39.3848 52.7603 39.5489 52.3641 39.841 52.072C40.1331 51.7798 40.5293 51.6157 40.9425 51.6157Z'
      fill='url(#paint5_linear_515_248)'
    />
    <path
      d='M50.2882 41.6543H53.4035C53.8167 41.6543 54.2129 41.8184 54.505 42.1105C54.7971 42.4027 54.9612 42.7989 54.9612 43.212V56.0265C54.9612 56.7062 54.4102 57.2572 53.7305 57.2572H49.9612C49.2815 57.2572 48.7305 56.7062 48.7305 56.0265V43.212C48.7305 42.7989 48.8946 42.4027 49.1867 42.1105C49.4788 41.8184 49.875 41.6543 50.2882 41.6543Z'
      fill='url(#paint6_linear_515_248)'
    />
    <path
      d='M40.9425 51.0005H44.0578C44.471 51.0005 44.8672 51.1646 45.1593 51.4567C45.4514 51.7489 45.6155 52.1451 45.6155 52.5582V56.0265C45.6155 56.7062 45.0645 57.2573 44.3848 57.2573H40.6155C39.9358 57.2573 39.3848 56.7062 39.3848 56.0265V52.5582C39.3848 52.1451 39.5489 51.7489 39.841 51.4567C40.1331 51.1646 40.5293 51.0005 40.9425 51.0005Z'
      fill='url(#paint7_linear_515_248)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.4044 55.8773C10.677 51.3331 14.8492 48.0005 19.7997 48.0005C24.6147 48.0005 28.6933 51.1532 30.084 55.5069H31.7968C36.4973 55.5069 40.3078 59.3174 40.3078 64.0179C40.3078 68.7184 36.4973 72.5289 31.7968 72.5289H11.8958C7.19529 72.5289 3.38477 68.7184 3.38477 64.0179C3.38477 60.1842 5.91945 56.9426 9.4044 55.8773Z'
      fill='url(#paint8_linear_515_248)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.96336 53.5297C9.03624 48.4815 13.999 44.9233 19.7995 44.9233C25.1712 44.9233 29.824 47.9751 32.1288 52.4344C38.375 52.6102 43.3845 57.7289 43.3845 64.0177C43.3845 70.4175 38.1964 75.6056 31.7966 75.6056H11.8956C5.49573 75.6056 0.307617 70.4175 0.307617 64.0177C0.307617 59.3783 3.0321 55.3817 6.96336 53.5297ZM9.40417 55.8771C10.6768 51.3329 14.8489 48.0003 19.7995 48.0003C24.6145 48.0003 28.6931 51.1529 30.0838 55.5066H31.7966C36.4971 55.5066 40.3076 59.3172 40.3076 64.0177C40.3076 68.7182 36.4971 72.5287 31.7966 72.5287H11.8956C7.19506 72.5287 3.38454 68.7182 3.38454 64.0177C3.38454 60.184 5.91923 56.9423 9.40417 55.8771Z'
      fill='#ffffff'
    />
    <path
      d='M13.8317 67.6683C13.2286 67.6683 12.6507 67.5893 12.0979 67.4314C11.545 67.2662 11.0999 67.0544 10.7625 66.796L11.3548 65.4821C11.6779 65.7119 12.0584 65.9021 12.4963 66.0529C12.9415 66.1965 13.3902 66.2683 13.8425 66.2683C14.1871 66.2683 14.4635 66.236 14.6717 66.1714C14.8871 66.0996 15.045 66.0027 15.1456 65.8806C15.2461 65.7585 15.2963 65.6185 15.2963 65.4606C15.2963 65.2596 15.2173 65.1016 15.0594 64.9868C14.9015 64.8647 14.6932 64.7678 14.4348 64.696C14.1763 64.617 13.8891 64.5452 13.5732 64.4806C13.2645 64.4088 12.9522 64.3227 12.6363 64.2221C12.3276 64.1216 12.044 63.9924 11.7856 63.8344C11.5271 63.6765 11.3153 63.4683 11.1502 63.2098C10.9922 62.9514 10.9132 62.6211 10.9132 62.2191C10.9132 61.7883 11.0281 61.397 11.2579 61.0452C11.4948 60.6862 11.8466 60.4027 12.3132 60.1944C12.7871 59.9791 13.3794 59.8714 14.0902 59.8714C14.564 59.8714 15.0307 59.9288 15.4902 60.0437C15.9497 60.1514 16.3553 60.3165 16.7071 60.5391L16.1686 61.8637C15.8168 61.6627 15.465 61.5155 15.1132 61.4221C14.7615 61.3216 14.4168 61.2714 14.0794 61.2714C13.742 61.2714 13.4656 61.3109 13.2502 61.3898C13.0348 61.4688 12.8804 61.5729 12.7871 61.7021C12.6938 61.8242 12.6471 61.9678 12.6471 62.1329C12.6471 62.3268 12.7261 62.4847 12.884 62.6068C13.042 62.7216 13.2502 62.815 13.5086 62.8868C13.7671 62.9585 14.0507 63.0303 14.3594 63.1021C14.6753 63.1739 14.9876 63.2565 15.2963 63.3498C15.6122 63.4432 15.8994 63.5688 16.1579 63.7268C16.4163 63.8847 16.6245 64.0929 16.7825 64.3514C16.9476 64.6098 17.0302 64.9365 17.0302 65.3314C17.0302 65.755 16.9117 66.1427 16.6748 66.4944C16.4379 66.8462 16.0825 67.1298 15.6086 67.3452C15.142 67.5606 14.5497 67.6683 13.8317 67.6683ZM20.5915 67.6683C20.0387 67.6683 19.5469 67.5785 19.1161 67.3991C18.6853 67.2196 18.3443 66.9755 18.093 66.6668C17.8418 66.358 17.7161 66.0027 17.7161 65.6006C17.7161 65.2273 17.7987 64.8934 17.9638 64.5991C18.1289 64.2975 18.391 64.0175 18.75 63.7591C19.1089 63.4934 19.5648 63.235 20.1177 62.9837C20.5197 62.797 20.8356 62.6319 21.0653 62.4883C21.2951 62.3447 21.4566 62.2083 21.55 62.0791C21.6433 61.9427 21.69 61.8062 21.69 61.6698C21.69 61.4832 21.6253 61.3324 21.4961 61.2175C21.3741 61.1027 21.191 61.0452 20.9469 61.0452C20.6884 61.0452 20.4874 61.1098 20.3438 61.2391C20.2002 61.3683 20.1284 61.5334 20.1284 61.7344C20.1284 61.8421 20.15 61.9498 20.193 62.0575C20.2361 62.158 20.3187 62.2765 20.4407 62.4129C20.5628 62.5421 20.7351 62.7109 20.9577 62.9191L24.9315 66.6021L24.0161 67.6683L19.633 63.5975C19.3818 63.3678 19.1807 63.1524 19.03 62.9514C18.8792 62.7503 18.7679 62.5529 18.6961 62.3591C18.6315 62.1652 18.5992 61.9642 18.5992 61.756C18.5992 61.3898 18.6961 61.0668 18.89 60.7868C19.0838 60.5068 19.3566 60.2914 19.7084 60.1406C20.0602 59.9827 20.473 59.9037 20.9469 59.9037C21.3848 59.9037 21.7618 59.9755 22.0777 60.1191C22.4007 60.2555 22.652 60.4529 22.8315 60.7114C23.0182 60.9698 23.1115 61.2785 23.1115 61.6375C23.1115 61.9534 23.0325 62.2442 22.8746 62.5098C22.7166 62.7683 22.4689 63.0124 22.1315 63.2421C21.8012 63.4719 21.3669 63.7052 20.8284 63.9421C20.4623 64.1073 20.1715 64.2688 19.9561 64.4268C19.7479 64.5775 19.5971 64.7319 19.5038 64.8898C19.4105 65.0478 19.3638 65.2237 19.3638 65.4175C19.3638 65.597 19.4177 65.7585 19.5253 65.9021C19.6402 66.0457 19.7982 66.157 19.9992 66.236C20.2002 66.315 20.4371 66.3544 20.71 66.3544C21.1479 66.3544 21.55 66.2539 21.9161 66.0529C22.2823 65.8447 22.591 65.5396 22.8423 65.1375C23.1007 64.7283 23.2838 64.2329 23.3915 63.6514L24.7377 64.0714C24.5869 64.8037 24.3177 65.4391 23.93 65.9775C23.5423 66.516 23.0648 66.9324 22.4977 67.2268C21.9305 67.5211 21.2951 67.6683 20.5915 67.6683ZM26.0573 67.5391V60.0006H29.7404C30.6881 60.0006 31.3988 60.1801 31.8727 60.5391C32.3537 60.898 32.5942 61.3719 32.5942 61.9606C32.5942 62.3555 32.4973 62.7001 32.3035 62.9944C32.1096 63.2816 31.844 63.5042 31.5065 63.6621C31.1691 63.8201 30.7814 63.8991 30.3435 63.8991L30.5481 63.4575C31.0219 63.4575 31.4419 63.5365 31.8081 63.6944C32.1742 63.8452 32.4578 64.0714 32.6588 64.3729C32.8671 64.6744 32.9712 65.0442 32.9712 65.4821C32.9712 66.1283 32.7163 66.6344 32.2065 67.0006C31.6968 67.3596 30.9465 67.5391 29.9558 67.5391H26.0573ZM27.7912 66.2252H29.8265C30.2788 66.2252 30.6199 66.1534 30.8496 66.0098C31.0865 65.8591 31.205 65.6221 31.205 65.2991C31.205 64.9832 31.0865 64.7498 30.8496 64.5991C30.6199 64.4411 30.2788 64.3621 29.8265 64.3621H27.6619V63.0914H29.525C29.9486 63.0914 30.2717 63.0196 30.4942 62.876C30.724 62.7252 30.8388 62.4991 30.8388 62.1975C30.8388 61.9032 30.724 61.6842 30.4942 61.5406C30.2717 61.3898 29.9486 61.3144 29.525 61.3144H27.7912V66.2252Z'
      fill='#252C7E'
    />
    <path
      d='M13.8317 67.0531C13.2286 67.0531 12.6507 66.9741 12.0979 66.8161C11.545 66.651 11.0999 66.4392 10.7625 66.1808L11.3548 64.8669C11.6779 65.0966 12.0584 65.2869 12.4963 65.4377C12.9415 65.5813 13.3902 65.6531 13.8425 65.6531C14.1871 65.6531 14.4635 65.6208 14.6717 65.5561C14.8871 65.4843 15.045 65.3874 15.1456 65.2654C15.2461 65.1433 15.2963 65.0033 15.2963 64.8454C15.2963 64.6443 15.2173 64.4864 15.0594 64.3715C14.9015 64.2495 14.6932 64.1525 14.4348 64.0808C14.1763 64.0018 13.8891 63.93 13.5732 63.8654C13.2645 63.7936 12.9522 63.7074 12.6363 63.6069C12.3276 63.5064 12.044 63.3772 11.7856 63.2192C11.5271 63.0613 11.3153 62.8531 11.1502 62.5946C10.9922 62.3361 10.9132 62.0059 10.9132 61.6038C10.9132 61.1731 11.0281 60.7818 11.2579 60.43C11.4948 60.071 11.8466 59.7874 12.3132 59.5792C12.7871 59.3638 13.3794 59.2561 14.0902 59.2561C14.564 59.2561 15.0307 59.3136 15.4902 59.4284C15.9497 59.5361 16.3553 59.7013 16.7071 59.9238L16.1686 61.2484C15.8168 61.0474 15.465 60.9002 15.1132 60.8069C14.7615 60.7064 14.4168 60.6561 14.0794 60.6561C13.742 60.6561 13.4656 60.6956 13.2502 60.7746C13.0348 60.8536 12.8804 60.9577 12.7871 61.0869C12.6938 61.209 12.6471 61.3525 12.6471 61.5177C12.6471 61.7115 12.7261 61.8695 12.884 61.9915C13.042 62.1064 13.2502 62.1997 13.5086 62.2715C13.7671 62.3433 14.0507 62.4151 14.3594 62.4869C14.6753 62.5587 14.9876 62.6413 15.2963 62.7346C15.6122 62.8279 15.8994 62.9536 16.1579 63.1115C16.4163 63.2695 16.6245 63.4777 16.7825 63.7361C16.9476 63.9946 17.0302 64.3213 17.0302 64.7161C17.0302 65.1397 16.9117 65.5274 16.6748 65.8792C16.4379 66.231 16.0825 66.5146 15.6086 66.73C15.142 66.9454 14.5497 67.0531 13.8317 67.0531ZM20.5915 67.0531C20.0387 67.0531 19.5469 66.9633 19.1161 66.7838C18.6853 66.6043 18.3443 66.3602 18.093 66.0515C17.8418 65.7428 17.7161 65.3874 17.7161 64.9854C17.7161 64.612 17.7987 64.2782 17.9638 63.9838C18.1289 63.6823 18.391 63.4023 18.75 63.1438C19.1089 62.8782 19.5648 62.6197 20.1177 62.3684C20.5197 62.1818 20.8356 62.0166 21.0653 61.8731C21.2951 61.7295 21.4566 61.5931 21.55 61.4638C21.6433 61.3274 21.69 61.191 21.69 61.0546C21.69 60.8679 21.6253 60.7172 21.4961 60.6023C21.3741 60.4874 21.191 60.43 20.9469 60.43C20.6884 60.43 20.4874 60.4946 20.3438 60.6238C20.2002 60.7531 20.1284 60.9182 20.1284 61.1192C20.1284 61.2269 20.15 61.3346 20.193 61.4423C20.2361 61.5428 20.3187 61.6613 20.4407 61.7977C20.5628 61.9269 20.7351 62.0956 20.9577 62.3038L24.9315 65.9869L24.0161 67.0531L19.633 62.9823C19.3818 62.7525 19.1807 62.5372 19.03 62.3361C18.8792 62.1351 18.7679 61.9377 18.6961 61.7438C18.6315 61.55 18.5992 61.349 18.5992 61.1408C18.5992 60.7746 18.6961 60.4515 18.89 60.1715C19.0838 59.8915 19.3566 59.6761 19.7084 59.5254C20.0602 59.3674 20.473 59.2884 20.9469 59.2884C21.3848 59.2884 21.7618 59.3602 22.0777 59.5038C22.4007 59.6402 22.652 59.8377 22.8315 60.0961C23.0182 60.3546 23.1115 60.6633 23.1115 61.0223C23.1115 61.3382 23.0325 61.629 22.8746 61.8946C22.7166 62.1531 22.4689 62.3972 22.1315 62.6269C21.8012 62.8566 21.3669 63.09 20.8284 63.3269C20.4623 63.492 20.1715 63.6536 19.9561 63.8115C19.7479 63.9623 19.5971 64.1166 19.5038 64.2746C19.4105 64.4325 19.3638 64.6084 19.3638 64.8023C19.3638 64.9818 19.4177 65.1433 19.5253 65.2869C19.6402 65.4305 19.7982 65.5418 19.9992 65.6208C20.2002 65.6997 20.4371 65.7392 20.71 65.7392C21.1479 65.7392 21.55 65.6387 21.9161 65.4377C22.2823 65.2295 22.591 64.9243 22.8423 64.5223C23.1007 64.1131 23.2838 63.6177 23.3915 63.0361L24.7377 63.4561C24.5869 64.1884 24.3177 64.8238 23.93 65.3623C23.5423 65.9008 23.0648 66.3172 22.4977 66.6115C21.9305 66.9059 21.2951 67.0531 20.5915 67.0531ZM26.0573 66.9238V59.3854H29.7404C30.6881 59.3854 31.3988 59.5649 31.8727 59.9238C32.3537 60.2828 32.5942 60.7566 32.5942 61.3454C32.5942 61.7402 32.4973 62.0849 32.3035 62.3792C32.1096 62.6664 31.844 62.889 31.5065 63.0469C31.1691 63.2049 30.7814 63.2838 30.3435 63.2838L30.5481 62.8423C31.0219 62.8423 31.4419 62.9213 31.8081 63.0792C32.1742 63.23 32.4578 63.4561 32.6588 63.7577C32.8671 64.0592 32.9712 64.429 32.9712 64.8669C32.9712 65.5131 32.7163 66.0192 32.2065 66.3854C31.6968 66.7443 30.9465 66.9238 29.9558 66.9238H26.0573ZM27.7912 65.61H29.8265C30.2788 65.61 30.6199 65.5382 30.8496 65.3946C31.0865 65.2438 31.205 65.0069 31.205 64.6838C31.205 64.3679 31.0865 64.1346 30.8496 63.9838C30.6199 63.8259 30.2788 63.7469 29.8265 63.7469H27.6619V62.4761H29.525C29.9486 62.4761 30.2717 62.4043 30.4942 62.2608C30.724 62.11 30.8388 61.8838 30.8388 61.5823C30.8388 61.2879 30.724 61.069 30.4942 60.9254C30.2717 60.7746 29.9486 60.6992 29.525 60.6992H27.7912V65.61Z'
      fill='#ffffff'
    />
    <defs>
      <linearGradient
        id='paint0_linear_515_248'
        x1='17.2314'
        y1='10.1543'
        x2='58.3837'
        y2='55.2165'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#2962FF' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_515_248'
        x1='25.2305'
        y1='25.0636'
        x2='34.1773'
        y2='33.512'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCBA73' />
        <stop offset='1' stopColor='#C86904' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_515_248'
        x1='47.0771'
        y1='7.07719'
        x2='53.3515'
        y2='19.1338'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2962FF' />
        <stop offset='1' stopColor='#8CB9FE' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_515_248'
        x1='23.6924'
        y1='7.07719'
        x2='29.9667'
        y2='19.1338'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2962FF' />
        <stop offset='1' stopColor='#8CB9FE' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_515_248'
        x1='61.1925'
        y1='32.3081'
        x2='61.1925'
        y2='57.2312'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C86904' />
        <stop offset='1' stopColor='#FCBA73' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_515_248'
        x1='42.4617'
        y1='60.9234'
        x2='42.4617'
        y2='51.6926'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2962FF' />
        <stop offset='1' stopColor='#8CB9FE' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_515_248'
        x1='51.9997'
        y1='57.2312'
        x2='51.9997'
        y2='41.5389'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#2962FF' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_515_248'
        x1='42.4617'
        y1='57.2313'
        x2='42.4617'
        y2='51.0774'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#2962FF' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_515_248'
        x1='8.9463'
        y1='57.3184'
        x2='22.6084'
        y2='70.9805'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#414CC8' />
        <stop offset='1' stopColor='#2B3493' />
      </linearGradient>
    </defs>
  </svg>,
  'SB',
);
